module.exports = __webpack_public_path__ + "static/img/live_type01.17c5b86a.png";